import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { LocationData } from '~admin/model/location-data';
import { mapLocationDataList } from '~admin/model/location-data.mapper';
import { LocationProfileResponse } from '~client/model/location-profile-response';
import { NoArgTask, rxTask } from '~common/helper/mobx-tasks';

export type GetLocationsTask = NoArgTask<LocationData[]>;

const performGetLocations = (): Observable<LocationProfileResponse[]> =>
  apiClient.locationProfileAdminController.getListOfLocations$();

export const getLocationsTaskFactory = (): GetLocationsTask =>
  rxTask<LocationData[]>(() => performGetLocations().pipe(map(mapLocationDataList)));



// WEBPACK FOOTER //
// ./interactor/location/perform-get-locations.ts